import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { MdCalendarToday } from "react-icons/md";
import { ko } from "date-fns/locale";
import { isSpecialUser } from "../../../../../utils/environment";
import "react-datepicker/dist/react-datepicker.css";

registerLocale("ko", ko);

/**
 * 광고 시작일/종료일 공통 날짜 선택기.
 * - weekdaysOnly: true면 주말(토·일) 선택 불가 (광고 시작일용), false면 모든 날짜 선택 가능 (광고 종료일용)
 * - 한글 로케일 적용
 */
const WeekdayOnlyDatePicker = ({
  value,
  onChange,
  minDate,
  maxDate,
  disabled,
  placeholderText = "날짜 선택",
  className = "",
  weekdaysOnly = true,
  userId = null,
}) => {
  const selected = value ? new Date(value + "T12:00:00") : null;
  const min = minDate ? new Date(minDate + "T12:00:00") : undefined;
  const max = maxDate ? new Date(maxDate + "T12:00:00") : undefined;
  const userIsSpecial = isSpecialUser(userId);
  const shouldBlockWeekends = weekdaysOnly && !userIsSpecial;

  const handleChange = (date) => {
    if (date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      onChange(`${y}-${m}-${d}`);
    } else {
      onChange("");
    }
  };

  const isWeekday = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  };

  return (
    <div className="weekday-datepicker-wrap">
      <DatePicker
        selected={selected}
        onChange={handleChange}
        minDate={min}
        maxDate={max}
        filterDate={shouldBlockWeekends ? isWeekday : undefined}
        dateFormat="yyyy년 MM월 dd일"
        placeholderText={placeholderText}
        disabled={disabled}
        locale="ko"
        className={`weekday-datepicker-input ${className}`}
        onKeyDown={(e) => e.preventDefault()}
        onPaste={(e) => e.preventDefault()}
      />
      <span className="weekday-datepicker-icon" aria-hidden="true">
        <MdCalendarToday />
      </span>
    </div>
  );
};

export default WeekdayOnlyDatePicker;
